import { render, staticRenderFns } from "./ModalReportUser.vue?vue&type=template&id=08894892&scoped=true"
import script from "./ModalReportUser.vue?vue&type=script&lang=js"
export * from "./ModalReportUser.vue?vue&type=script&lang=js"
import style0 from "./ModalReportUser.vue?vue&type=style&index=0&id=08894892&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08894892",
  null
  
)

export default component.exports